import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import customLanguageTexts from '../../../language'
import { getPlanName } from '../../../helpers'
import './index.css'

const ModalSubscriptionDowngradeEOTCancelled = () => {
  const settings = useSelector(state => state.settings)
  const apps = useSelector(state => state.apps)
  const dispatch = useDispatch()

  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'subscriptionDowngradeEOTCancelled'
  const visible = modalID === visibleModalID

  return (
    <Modal
      className="custom__downgradeEOT__modal"
      title={
        <div> {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_CANCELLED_MODAL_TITLE}</div>
      }
      open={visible}
      onCancel={handleCancel}
      footer={null}
      maskClosable={false}
    >
      <div className="">
        {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_CANCELLED_MODAL_DESCRIPTION}
        <b>{getPlanName(apps.active)}</b>
        <br />
        {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_CANCELLED_MODAL_NOTE}{' '}
        <i className="fe fe-smile ml-2" />
      </div>
    </Modal>
  )
}

export default ModalSubscriptionDowngradeEOTCancelled
